import { render, staticRenderFns } from "./welfareLimit.vue?vue&type=template&id=7aa3d08a&scoped=true"
import script from "./welfareLimit.vue?vue&type=script&lang=js"
export * from "./welfareLimit.vue?vue&type=script&lang=js"
import style0 from "./welfareLimit.vue?vue&type=style&index=0&id=7aa3d08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa3d08a",
  null
  
)

export default component.exports